
import { CipherQuestion } from '../cipherTypes';

export const useQuizLogic = () => {
  const isMultiSelectQuestion = (index: number) => {
    // Question 4 (index 3) is our multi-select question
    return index === 3;
  };

  const checkAnswer = (
    currentQuestion: CipherQuestion,
    currentQuestionIndex: number,
    selectedOption: string | null,
    selectedOptions: string[]
  ) => {
    if (isMultiSelectQuestion(currentQuestionIndex)) {
      // For question 4, we need to check if they selected the correct options
      const correctOptions = currentQuestion.correctAnswer.split(", ");
      const hasAllCorrect = correctOptions.every(opt => selectedOptions.includes(opt));
      const hasNoIncorrect = selectedOptions.every(opt => correctOptions.includes(opt));
      return hasAllCorrect && hasNoIncorrect;
    } else {
      // For single-select questions
      return selectedOption === currentQuestion.correctAnswer;
    }
  };

  return {
    isMultiSelectQuestion,
    checkAnswer
  };
};
